import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import styled from './Theme';
import Header from './Header';
import Footer from './Footer';
import UIFloatingAlertList from 'UIComponents/alert/UIFloatingAlertList';
const Main = styled.main.withConfig({
  displayName: "Layout__Main",
  componentId: "sc-6dzbrb-0"
})(["max-width:1280px;padding:40px;margin:auto;@media (max-width:", "){padding:12px;overflow-x:hidden;}"], props => props.theme.sizes.GRID_BREAKPOINT_SMALL);
const LayoutWrapper = styled.div.withConfig({
  displayName: "Layout__LayoutWrapper",
  componentId: "sc-6dzbrb-1"
})(["display:grid;grid-template-rows:auto 1fr auto;min-height:100vh;> *{width:100%;height:100%;}"]);

const Layout = ({
  children
}) => {
  return /*#__PURE__*/_jsxs(LayoutWrapper, {
    children: [/*#__PURE__*/_jsx(Header, {}), /*#__PURE__*/_jsx(UIFloatingAlertList, {}), /*#__PURE__*/_jsx(Main, {
      children: children
    }), /*#__PURE__*/_jsx(Footer, {})]
  });
};

export default Layout;